import $x from '@/utils/$x';

// 优加训练计划库（经 workwx BFF → litta-user-plan）
export async function prescriptionPlanList(params) {
  return $x.post('/prescription/plan/list', params);
}

export async function prescriptionPlanDetail(params) {
  return $x.post('/prescription/plan/detail', params);
}

export async function prescriptionDict(params) {
  return $x.post('/prescription/plan/dict', params);
}

// 页面导入：粘贴 skill 产出的 PlanPackage，生成真实训练计划并入库（导入即上架）
export async function prescriptionPlanImport(params) {
  return $x.post('/prescription/plan/import', params);
}

// 刷新计划内容快照：把 ptainer 计划详情 + 课程模板/动作明细物化落库（交付与计划页随后直接读快照）
export async function prescriptionPlanRefreshContent(params) {
  return $x.post('/prescription/plan/refreshContent', params);
}

// 计划内容快照（详情页「立刻报文」）：交付给立刻的 trainingInfo（优加 createOrder 契约）+ 计划页 courses + planSummary
export async function prescriptionPlanContent(params) {
  return $x.post('/prescription/plan/content', params);
}
